// TypeScript
import { z } from "zod";

import { StrapiMediaSchema } from "./media.schema";

/**
 * Упростим rich-text до HTML-строки (или JSON AST — если используете editor-формат).
 * При необходимости замените на дискриминированный союз форматов.
 */
// export const RichTextSchema = z.object({
//   kind: z.literal("html"),
//   html: z.string().default(""),
// });

const TextFormatSchema = z
  .object({
    text: z.string(),
    type: z.literal("text"),
    bold: z.boolean().optional(),
    italic: z.boolean().optional(),
    underline: z.boolean().optional(),
    strikethrough: z.boolean().optional(),
    code: z.boolean().optional(),
  })
  .strict();

const LinkChildSchema = z
  .object({
    text: z.string(),
    type: z.literal("text"),
  })
  .strict();

const LinkNodeSchema = z
  .object({
    text: z.string(),
    url: z.string().url(),
    type: z.literal("link"),
    children: z.array(LinkChildSchema).min(0),
  })
  .strict();

const InlineNodeSchema = z.union([TextFormatSchema, LinkNodeSchema.extend({})]);

const ImageBlockSchema = z
  .object({
    type: z.literal("image"),
    image: StrapiMediaSchema,
    children: z.array(InlineNodeSchema).min(0),
  })
  .strict()
  .optional();

const HeadingBlockSchema = z
  .object({
    type: z.literal("heading"),
    level: z.union([
      z.literal(1),
      z.literal(2),
      z.literal(3),
      z.literal(4),
      z.literal(5),
      z.literal(6),
    ]),
    children: z.array(InlineNodeSchema).min(0),
  })
  .strict()
  .optional();

const ParagraphBlockSchema = z
  .object({
    type: z.literal("paragraph"),
    children: z.array(InlineNodeSchema).min(0),
  })
  .strict();

const ListItemBlockSchema = z
  .object({
    type: z.literal("list-item"),
    children: z.array(InlineNodeSchema).min(0),
  })
  .strict()
  .optional();

const ListBlockSchema = z
  .object({
    type: z.literal("list"),
    format: z.union([z.literal("ordered"), z.literal("unordered")]),
    children: z.array(ListItemBlockSchema).min(0),
  })
  .strict()
  .optional();

const QuoteBlockSchema = z
  .object({
    type: z.literal("quote"),
    children: z.array(InlineNodeSchema).min(0),
  })
  .strict()
  .optional();

export const RichTextSchema = z.union([
  HeadingBlockSchema,
  ParagraphBlockSchema,
  ListBlockSchema,
  QuoteBlockSchema,
  ImageBlockSchema,
]);

export const RichTextContentSchema = z.array(RichTextSchema).min(0).nullable();

export type RichText = z.infer<typeof RichTextContentSchema>;
